export const SHOW_NOTIFY = '@notifications/SHOW_NOTIFY';
